import '../styles/Navbar.css';
import React from 'react';

const PAGE_ROUTES = {
  Landing: '/',
  'Sign Up': '/sign-up',
  Login: '/login',
};

function SpiderMark() {
  return (
    <span className="nv-mark" aria-hidden="true">
      <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="16" cy="16" r="2.1" fill="currentColor" stroke="none" />
        <path d="M16 13.9c0-3.2 0-5.4 0-7.2" />
        <path d="M14.4 13.6c-2-2.2-3.6-3.6-5.4-4.8M17.6 13.6c2-2.2 3.6-3.6 5.4-4.8" />
        <path d="M14.2 15.4c-2.6-1-4.9-1.5-7-1.6M17.8 15.4c2.6-1 4.9-1.5 7-1.6" />
        <path d="M14.2 17.2c-2.5 1.2-4.3 2.6-5.7 4.4M17.8 17.2c2.5 1.2 4.3 2.6 5.7 4.4" />
        <path d="M15 18.2c-1.4 2.1-2.2 4-2.7 6.1M17 18.2c1.4 2.1 2.2 4 2.7 6.1" />
      </svg>
    </span>
  );
}

function Navbar({ activePage }) {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '/';
  const resolved =
    typeof activePage === 'string' && activePage.trim() !== ''
      ? activePage
      : Object.keys(PAGE_ROUTES).find((name) => PAGE_ROUTES[name] === pathname) || '';

  return (
    <header className="nv-bar">
      <nav className="nv-inner" aria-label="Primary">
        <a
          className="nv-brand"
          href="/"
          aria-current={resolved === 'Landing' ? 'page' : undefined}
        >
          <SpiderMark />
          <span className="nv-word">dbaseextractor</span>
        </a>
        <div className="nv-actions">
          <a
            className="nv-cta"
            href="/sign-up"
            aria-current={resolved === 'Sign Up' ? 'page' : undefined}
          >
            Sign Up
          </a>
          <a
            className="nv-link"
            href="/login"
            aria-current={resolved === 'Login' ? 'page' : undefined}
          >
            Login
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;